import { TenantIsActiveOrderDeltaRequest, ProjectIsActiveResponse, ScopeStepTypeClient, ExportDataModel, ExportProjectsDataModel } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import store from 'base/reducer/store';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import { FetchingProjectItemsActionType, PersistProjectItemsActionType } from 'features/Persist/actionTypes';

export const getStepTypesAction = (projectId: number) => {
	const tenantId = getTenantId()!;
	const client = new ScopeStepTypeClient();
	return client.getAll(tenantId, projectId);
}

export const updateStepTypesAction = (projectId: number, delta: TenantIsActiveOrderDeltaRequest) => {
	const tenantId = getTenantId()!;
	const client = new ScopeStepTypeClient();
	return client.update(tenantId, projectId, delta);
}
export const exportStepTypesAction = (projectIds: number[], exportDataModel: ExportDataModel) => {
	const tenantId = getTenantId()!;
	const exportProjectsDataModel = new ExportProjectsDataModel({
		...exportDataModel,
		projectIds
	});
	const client = new ScopeStepTypeClient();
	return client.export(tenantId, exportProjectsDataModel);
}

export const persistStepTypesAction = async (projectId: number) => {
	const state = store.getState();

	if (state.persistedProjectTeam.projectMap[projectId]?.fetching) {
		return;
	}

	store.dispatch(setStepTypesFetchingAction(true, projectId));

	const bindedAction = getStepTypesAction.bind(null, projectId);
	const response = await tryCatchJsonByAction(bindedAction);

	if (response.success && response.items) {
		store.dispatch(setStepTypesAction(projectId, response.items || []));
	} else {
		store.dispatch(setStepTypesFetchingAction(false, projectId));
	}
}

// persist step types redux

export const STEP_TYPES_FETCHING = 'STEP_TYPES_FETCHING';
export const STEP_TYPES_SET = 'STEP_TYPES_SET';

const setStepTypesFetchingAction = (fetching: boolean, projectId: number): FetchingProjectItemsActionType => {
	return {
		type: STEP_TYPES_FETCHING,
		fetching,
		projectId
	}
}

const setStepTypesAction = (projectId: number, items: ProjectIsActiveResponse[]): PersistProjectItemsActionType<ProjectIsActiveResponse> => {
	return {
		type: STEP_TYPES_SET,
		items,
		projectId
	}
}
